import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { createBaseLayer, type BasemapType } from '../utils/basemap';

/**
 * 背景地図を1枚置くだけのコンポーネント（react-leaflet の <TileLayer> の代わり）。
 *
 * 会社ごとのフラグで「自社配信の地図」と「従来の外部タイル」が切り替わるため、
 * 画面側は種類（標準/衛星）だけ指定して、中身は utils/basemap.ts に任せる。
 */
export default function BaseTileLayer({ type = 'standard' }: { type?: BasemapType }) {
  const map = useMap();

  useEffect(() => {
    const layer = createBaseLayer(type);
    layer.addTo(map);
    return () => { map.removeLayer(layer); };
  }, [map, type]);

  return null;
}
